import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import Nav from '../components/Nav';
import { NAV_ANIMATION_DURATION_MS } from '../constants';

const Home = () => {
  // const KEY_CODES = {
  //   enter: 13,
  //   space: 32
  // };

  const [contentSelection, setContentSelection] = useState<
    string | undefined
  >();
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (contentSelection) {
      setIsAnimating(true);
      const timer = setTimeout(() => {
        setIsAnimating(false);
      }, NAV_ANIMATION_DURATION_MS);

      return () => clearTimeout(timer);
    }
  }, [contentSelection]);

  return (
    <>
      <Nav
        contentSelection={contentSelection}
        setContentSelection={setContentSelection}
      />
      <div id="main-content" role="main">
        {!isAnimating && <Outlet />}
      </div>
    </>
  );
};

export default Home;
